import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type MixdeskProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Mixdesk = ({ size = 24, width, height, alt = '', style, ...props }: MixdeskProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'matrix(0.94161959 0 0 0.94161959 0.70056497 0.70056497)',
        },
        [
          h(
            'defs',
            {
            },
            [
              h(
                'mask',
                {
                  id: 'logo-mask',
                  maskUnits: 'userSpaceOnUse',
                  maskContentUnits: 'userSpaceOnUse',
                  x: '0',
                  y: '0',
                  width: '64',
                  height: '64',
                },
                [
                  h(
                    'rect',
                    {
                      width: '64',
                      height: '64',
                      fill: 'white',
                    },
                  ),
                  h(
                    'rect',
                    {
                      x: '23.6734693',
                      y: '29.4399224',
                      width: '4.4790695',
                      height: '7.0400458',
                      rx: '2.2395348',
                      fill: 'black',
                    },
                  ),
                ],
              ),
            ],
          ),
          h(
            'path',
            {
              fill: '#00DA5D',
              "fill-rule": 'evenodd',
              "clip-rule": 'evenodd',
              mask: 'url(#logo-mask)',
              transform: 'translate(2.440055 1.375) scale(0.33203125)',
              d: 'M25.913004,29.4399224 C24.676146,29.4399224 23.6734693,30.4428714 23.6734693,31.6800653 L23.6734693,34.2398254 C23.6734693,35.4770192 24.676146,36.4799682 25.913004,36.4799682 C27.149862,36.4799682 28.1525388,35.4770192 28.1525388,34.2398254 L28.1525388,31.6800653 C28.1525388,30.4428714 27.149862,29.4399224 25.913004,29.4399224 L25.913004,29.4399224 Z M8.95743359,31.6800653 C8.95743359,30.4428714 9.96011033,29.4399224 11.1969683,29.4399224 C12.4338263,29.4399224 13.4365031,30.4428714 13.4365031,31.6800653 L13.4365031,34.2398254 C13.4365031,35.4770192 12.4338263,36.4799682 11.1969683,36.4799682 C9.96011033,36.4799682 8.95743359,35.4770192 8.95743359,34.2398254 L8.95743359,31.6800653 Z M31.9950161,-0.000141111362 C33.5496411,-0.000141111362 35.4692927,0.160020285 35.9591689,0.275026045 C36.4490451,0.390031805 36.7389502,0.578768252 36.7389502,0.914966073 C36.7389502,1.25081111 36.5139387,1.37498911 36.1739526,1.53479773 C36.1503229,1.54608664 36.1111751,1.56125611 36.0575674,1.58207004 C35.7288671,1.70907026 34.8707903,2.04068196 33.9294803,2.85983342 C32.8351061,3.81233512 32.0704902,4.87525645 31.9914892,5.31199612 C31.9121357,5.74838301 32.0627311,6.03977797 32.6312556,5.94981948 C32.750815,5.93076944 32.9624245,5.85456931 33.2632628,5.74626634 C34.3904365,5.33951284 36.7738658,4.47979186 40.3091565,4.47979186 C44.7878733,4.47979186 48.0381965,5.96992785 48.5770956,6.26978949 C49.115642,6.57000391 49.3152603,6.84481829 49.3152603,7.11998545 C49.3152603,7.39479983 49.1558478,7.67173087 48.6268238,7.67984478 C46.7061142,7.70983094 45.8021886,7.93349245 45.1864047,8.17973178 C44.5709735,8.42632388 43.9530735,8.72442164 43.9530735,9.13752515 C43.9530735,9.52946196 44.3353815,9.55415645 44.9458752,9.59331485 L45.0439209,9.60001764 C46.1890815,9.67551222 48.3101148,9.93974324 50.3690761,10.5500499 C52.4287427,11.1600037 55.5651493,13.0741794 56.0917045,13.6241609 C56.6175543,14.1741424 56.0980528,14.7999713 55.6681327,14.7498768 C55.2382125,14.6997823 54.2380046,14.5943015 53.5157105,14.5900682 C53.4243657,14.5893626 53.3347843,14.5879515 53.2469664,14.5868932 C52.6392942,14.5787793 52.1363687,14.5720765 52.0358542,14.7950324 C51.9501523,14.9855328 52.2732096,15.3100889 52.501748,15.5390421 C52.5782801,15.6166533 52.6449371,15.6829757 52.6809107,15.7298952 C52.6879644,15.7394202 52.7070093,15.7609397 52.7366346,15.7951592 C53.2931678,16.432277 57.5846101,21.3485969 57.5846101,28.7999824 C57.5846101,35.3979969 52.8745335,39.3579345 48.5668678,42.9809687 C44.934942,46.0346186 41.5886891,48.8480264 41.5886891,52.7998501 C41.5886891,55.359963 43.1884576,58.2400459 45.4276396,58.2400459 C47.0274081,58.2400459 47.9870575,56.959813 47.9870575,55.679933 C47.9870575,54.4000529 47.0274081,53.1198201 45.4276396,53.1198201 C45.0756624,53.1198201 44.7878733,52.8319529 44.7878733,52.4798801 C44.7878733,52.1278072 45.0756624,51.83994 45.4276396,51.83994 C49.5864733,51.83994 51.1862417,55.6160801 51.1862417,57.6001058 C51.1862417,61.1201288 47.9870575,63.9998589 42.8685744,63.9998589 C35.8304397,63.9998589 30.711604,58.2400459 30.711604,51.83994 C30.711604,48.6398871 31.9988956,46.3923359 31.9988956,46.3923359 C31.9988956,46.3923359 27.5124198,49.9201199 19.8345188,49.9201199 C8.63755044,49.9201199 0,41.5998412 0,30.7198024 C0,16.6400635 12.4803804,-0.000141111362 31.9950161,-0.000141111362 Z',
            },
          ),
        ],
      ),
    ],
  );

export default Mixdesk;
